import React from 'react';

function EmailSigninUserInfo() {
  return <div>Working progress</div>;
}

export default EmailSigninUserInfo;
